import { AnyAction, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit'
import { logError } from '../../../utils/utils';
import { AppDispatch, RootState } from '../../../app/store';
import { errorHandler } from '../../../utils/errorHandling';
import { datenabrufState } from './datenabrufTypes';
import { datenabruf, messstelle } from '../../../utils/apiTypes';
import { getWithAuth, putWithAuth } from '../../../utils/api';
import { openSnackbar } from '../../../features/snackbar/globalSnackbarSlice';


export const serviceDummy: datenabruf = {
    id: 1,
    service: "",
    from: new Date(),
    to: new Date(),
    messstellen: [],
    kenngroessen: [],
    creationTime: new Date()
}

const initialState: datenabrufState = {
    datenabrufListe: [],
    datenabrufListeLoading: false,
    selectedDatenabruf: "",
    messstellen: [],
    kenngroessen: [],
    messstellenLoading: false,
    from: new Date(),
    to: new Date(),
    getLastX: 0,
    creationTime: new Date(),
    selectedRequest: 0,
    selectedRequestsList: [],
}

const stoerungsmanagementSlice = createSlice({
    name: "datenabruf",
    initialState,
    reducers: {
        setMessstellen: (state, action: PayloadAction<Array<messstelle>>) => {
            state.messstellen = action.payload;
        },
        setMessstellenLoading: (state, action: PayloadAction<boolean>) => {
            state.messstellenLoading = action.payload;
        },
        setDatenabrufListe: (state, action: PayloadAction<Array<datenabruf>>) => {
            state.datenabrufListe = action.payload
        },
        setDatenabrufListeLoading: (state, action: PayloadAction<boolean>) => {
            state.datenabrufListeLoading = action.payload;
        },
        setSelectedRequest: (state, action: PayloadAction<string>) => {
            if (state.selectedRequestsList.includes(action.payload)) {
                state.selectedRequestsList = state.selectedRequestsList.filter(x => x !== action.payload);
                console.log(state.selectedRequestsList);
            } else { state.selectedRequestsList.push(action.payload); console.log(state.selectedRequestsList); }
        },


    }
});

export const {
    setMessstellen,
    setMessstellenLoading,
    setDatenabrufListe,
    setDatenabrufListeLoading,
    setSelectedRequest

} = stoerungsmanagementSlice.actions

export const selectMessstellen = (state: RootState): Array<messstelle> => state.datenabruf.messstellen;
export const selectMesssstellenLoading = (state: RootState): boolean => state.datenabruf.messstellenLoading;
export const selectDatenabrufListe = (state: RootState): Array<datenabruf> => state.datenabruf.datenabrufListe;
export const selectDatenabrufListeLoading = (state: RootState): boolean => state.datenabruf.datenabrufListeLoading;
export const selectSelectedRequest = (state: RootState): number => state.datenabruf.selectedRequest;
export const selectSelectedRequestsList = (state: RootState): Array<string> => state.datenabruf.selectedRequestsList;

export const getMessstellen = () => (dispatch: AppDispatch): void => {
    dispatch(setMessstellenLoading(true));
    getWithAuth("MESSSTELLE", {})
        .then((response: any) => {
            dispatch(setMessstellen(response));
        })
        .catch((error: any) => {
            logError(error);
            errorHandler(error, dispatch);
        });
    dispatch(setMessstellenLoading(false));
};

export const getDatenabruf = () => (dispatch: AppDispatch): void => {
    dispatch(setDatenabrufListeLoading(true));
    getWithAuth("REQUEST", {})
        .then((response: Array<datenabruf>) => {
            const datenabruf: Array<datenabruf> = response.map(x => ({ id: x.id, service: x.service, from: x.from, to: x.to, messstellen: x.messstellen, kenngroessen: x.kenngroessen, creationTime: x.creationTime }));
            dispatch(setDatenabrufListe(datenabruf));
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setDatenabrufListeLoading(false)));
}

export const resetRequest = (id: number): ThunkAction<void, RootState, unknown, AnyAction> => (
    dispatch: AppDispatch
) => {
    dispatch(setDatenabrufListeLoading(true));
    putWithAuth("RESETREQUEST", {}, id, id.toString())
        .then(() => {
            console.log(id)
            dispatch(
                openSnackbar({
                    message: `Der Dienst wurde zurückgesetzt.`,
                    severity: "success",
                    duration: 6000,
                })
            );

        }
        )
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setDatenabrufListeLoading(false)));

};

export default stoerungsmanagementSlice.reducer